import React from 'react';
import Title from '../../components/Title/Title';
import Auxiliary from '../../util/Auxiliary';
import Form from './Form/Index';

const Create = () => {
  return (
    <Auxiliary>
      <Title>Update Pelanggaran</Title>
      <Form />
    </Auxiliary>
  );
}

export default Create;